import React, { Component } from "react";
import { Route } from "react-router";
import {
  DudasFrecuentes,
  FileManager,
  LicenciaClaseA1,
  LicenciaClaseA1A2,
  LicenciaClaseA2,
  LicenciaClaseA3,
  LicenciaClaseA4,
  LicenciaClaseA5,
  LicenciaClaseB,
  LicenciaClaseC,
  LicenciaClaseCR,
  LicenciaClaseD,
  LicenciaClaseE,
  ObtencionLicencia,
  TipsCiclos,
  NoOlvidarEstudiarEstoClaseB,
  NoOlvidarEstudiarEstoClaseC,
  Fyac,
  DudasSugerencias,
  LicenciaClaseBENG,
  DS962018,
  Ciclos,

} from "../components/Pages";
import HomeContainer from "./HomeContainer";

class ContentContainer extends Component {
  render() {
    return (
      <div>
        <Route exact path="/" component={HomeContainer} />
        <Route path="/LicenciaClaseA1" component={LicenciaClaseA1} />
        <Route path="/LicenciaClaseA1A2" component={LicenciaClaseA1A2} />
        <Route path="/LicenciaClaseA2" component={LicenciaClaseA2} />
        <Route path="/LicenciaClaseA3" component={LicenciaClaseA3} />
        <Route path="/LicenciaClaseA4" component={LicenciaClaseA4} />
        <Route path="/LicenciaClaseA5" component={LicenciaClaseA5} />
        <Route path="/LicenciaClaseB" component={LicenciaClaseB} />
        <Route path="/licenciaClaseB-ENG" component={LicenciaClaseBENG} />
        <Route path="/LicenciaClaseC" component={LicenciaClaseC} />
        <Route path="/LicenciaClaseCR" component={LicenciaClaseCR} />
        <Route path="/LicenciaClaseD" component={LicenciaClaseD} />
        <Route path="/LicenciaClaseE" component={LicenciaClaseE} />
        <Route path="/ObtencionLicencia" component={ObtencionLicencia} />
        <Route path="/TipsCiclos" component={TipsCiclos} />
        <Route
          path="/NoOlvidarEstudiarEstoClaseB"
          component={NoOlvidarEstudiarEstoClaseB}
        />
        <Route
          path="/NoOlvidarEstudiarEstoClaseC"
          component={NoOlvidarEstudiarEstoClaseC}
        />
        <Route path="/FileManager" component={FileManager} />
        <Route path="/DudasFrecuentes" component={DudasFrecuentes} />
        <Route path="/fyac" component={Fyac} />
        <Route path="/dudasSugerencias" component={DudasSugerencias} />
        <Route path="/DS962018" component={DS962018} />
        <Route path="/Ciclos" component={Ciclos} />
      </div>
    );
  }
}

ContentContainer.propTypes = {};

export default ContentContainer;
